import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer.js';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop.js";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav/index.js';

import ModalOverlay from "../../components/ModalOverlay.js";

import heroMobileImage from '../../images/articles/P00138022_WF_BRAND_FY25_ISF_FebUpdate18_LP_767x577.jpg';
import heroDesktopImage from '../../images/articles/P00138022_WF_BRAND_FY25_ISF_FebUpdate18_LP_1164x584.jpg';

import { fireTag } from '../../libs/analytics.js';

const NuclearEnergy = ({
    handleEvent,
    closeExitOverlay,
    addExitClickListeners,
    modalOverlay,
}) => {

    const [enableScrollGA, setEnableScrollGA] = useState(false);
    const [shouldBeInert, setShouldBeInert] = useState(false);
    const [gridVisible, setGridVisible] = useState(false);

    const heroOGImage = 'P00138022_WF_BRAND_FY25_ISF_FebUpdate18_LP_ogimage.jpg';

    const toggleInert = () => {
        setShouldBeInert(!shouldBeInert)
    }

    const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}

	useEffect(() => {
		linkDisclosures();
		addExitClickListeners();

		// document.addEventListener('DOMContentLoaded', function() {
		// 	// Your code to run when the DOM is fully loaded
		// 	let script = document.createElement('script');
		// 	script.src = "https://public.flourish.studio/resources/embed.js";
	
		// 	document.querySelector('.flourish-embed').appendChild(script);
		//   });

	}, []); // empty array says only use this effect once

    let mastheadImage = window.innerWidth < 768 ? heroMobileImage : heroDesktopImage;

    return (
		<>
			<Helmet>
				<title>Top sustainability trends for 2025</title>
				<meta
					name="description"
					content="Wells Fargo’s Corporate & Investment Banking team shares insights on sustainability trends and their real-world impacts."
				/>
				<meta property="og:title" content="Top sustainability trends for 2025 "/>
				<meta
					property="og:description"
					content="Wells Fargo’s Corporate & Investment Banking team shares insights on sustainability trends and their real-world impacts."
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>

				<meta property="twitter:title" content="Top sustainability trends for 2025"/>
				<meta
					property="twitter:description"
					content="Wells Fargo’s Corporate & Investment Banking team shares insights on sustainability trends and their real-world impacts."
				/>
				i
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}

			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>

			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}


			<main className="flex-container">

				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
                        Top sustainability trends for 2025                      
                        </h1>
						<h2 className="summary">
                        Wells Fargo’s Corporate & Investment Banking team shares insights on sustainability trends and their real-world impacts.
                        </h2>
					</div>

				</div>

				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="An overhead view of a large field of solar panels with reflected sunlight."/>
					</div>
				</div>
                
				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro info-graphic">
                    <div className="by-line">
							<p>By Readie Callahan, <span>managing director, sustainable finance and advisory at Wells Fargo, Corporate & Investment Banking</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>February 18, 2025</p>
							</div>
							<div>
								<p>1-minute read</p>
							</div>
						</div>
						<p>Looking into sustainability themes for 2025, companies and policymakers are reevaluating strategies to not only manage increasing risks, but also capture opportunities for long-term growth. This dual imperative — strengthening resilience while unlocking value — will define the business landscape in the coming year.</p>
                        <p>Several forces are converging to reshape this environment. From the anticipation of reduced regulations in the U.S. to the rise of nuclear power, the energy sector offers new avenues for investment and operational stability. Demand for power is growing rapidly, but artificial intelligence and scientific advancement are creating potential pathways to improved efficiency and opportunity.</p>
						<p>The housing market and broader infrastructure sectors remain at the epicenter of climate-related challenges, highlighting the need for greater resiliency. Rising construction costs, frequent climate disasters, and escalating insurance premiums will demand innovative approaches to financing and risk mitigation. Businesses will need to navigate the interplay of regulatory shifts, competitive pressures, and technological advancements to build resilience and capitalize on new growth frontiers.</p>
						<p>Read the full list: <a onClick={()=> fireTag("A1","top 10")} target="_blank" href="https://www.wellsfargo.com/assets/pdf/cib/insights/2025-top-trends-sustainability.pdf?fireglass_rsn=true#fireglass_params&tabid=a4361edcb8401692&start_with_session_counter=2&application_server_address=wellsfargoprod11-us-east4.prod.fire.glass" rel="noreferrer">Top 10 Sustainability Trends for 2025</a></p>
					</div>
				</div>
			</main>


			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>

			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}
		</>
    );

};

export default withRouter(NuclearEnergy);



